import { Loading } from '@library/components/Loading';
import { MemberPollsTable } from '@bo-components/members/memberPolls';
import { useMemberDetails } from '@bo-hooks/members/useMemberDetails';
import { useMemo } from 'react';

export const MemberPolls = () => {
  const { memberProfile, isError, isLoading } = useMemberDetails();

  const memberUuid = useMemo(() => {
    if (!memberProfile) {
      return '';
    }
    return memberProfile.generalInfo.uuid.value;
  }, [memberProfile]);

  if (isLoading || !memberUuid?.length) {
    return <Loading loadingMessage="" />;
  }

  if (isError) {
    return (
      <section className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          Error Fetching Member Details
        </h1>
      </section>
    );
  }

  return (
    <section className="w-full px-6 pt-0">
      <MemberPollsTable memberUuid={memberUuid} />
    </section>
  );
};
